import moment from "moment";
import React from "react";
import { TBFL1Record } from "../../../../../redux/app/bfl-1/@types";
import { TBFL1A1 } from "../../../../../redux/app/bfl-1/groups/group-a";
import BFL1TableRows from "../BFL1TableRows";
import { IStore } from "../../../../../redux/store";
import { ConnectedProps, connect } from "react-redux";

type OwnProps = {
	bfl1Record: TBFL1Record;
	isStrikedOff?: boolean;
};
type BFL1A1PreviewProps = React.PropsWithChildren<OwnProps>;
function BFL1A1Preview(props: BFL1A1PreviewProps) {
	const bfl1Record = props.bfl1Record as TBFL1A1;
	const { item1, item2, item3, item4, item5, item6, item7, item8 } = bfl1Record;

	const operationDate = moment(bfl1Record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<BFL1TableRows
				record={bfl1Record}
				tableRows={[
					[operationDate, "A", "1", renderItemA1()],
					[null, null, "2", renderItemA2()],
					[null, null, "3", renderItemA3()],
					[null, null, "4", renderItemA4()],
					[null, null, "5", renderItemA5()],
					[null, null, "6", renderItemA6()],
					[null, null, "7", renderItemA7()],
					[null, null, "8", renderItemA8()],
					[null, null, "NOTE", bfl1Record.remarks],
				]}
			/>
		);
	}

	function renderItemA1() {
		if (item1.place === "PORT")
			return (
				<h6>
					{operationDate}, {item1.portName}
				</h6>
			);
		return (
			<h6>
				{operationDate}, <br />
				STARTED AT: {item1.startPosition.latitude},{" "}
				{item1.startPosition.longitude} <br />
				FINISHED AT: {item1.stopPosition.latitude},{" "}
				{item1.stopPosition.longitude}
			</h6>
		);
	}

	function renderItemA2() {
		if (item2.remarks) return item2.remarks;
		return null;
	}

	function renderItemA3() {
		if (item3.remarks) return item3.remarks;
		return null;
	}
	function renderItemA4() {
		if (item4.remarks) return item4.remarks;
		return null;
	}
	function renderItemA5() {
		if (item5.remarks) return item5.remarks;
		return null;
	}
	function renderItemA6() {
		if (item6.remarks) return item6.remarks;
		return null;
	}
	function renderItemA7() {
		if (item7.remarks) return item7.remarks;
		return null;
	}
	function renderItemA8() {
		if (item8.remarks) return item8.remarks;
		return null;
	}

	return renderMain();
}

export default BFL1A1Preview;
